import React, { useContext, useMemo } from "react";
import ITranslationsContext from "../../../infrastructure/context/translations/translations-context.interface";
import TranslationsContext from "../../../infrastructure/context/translations/translations-context";
import TranslationManager from "../../../infrastructure/translation-manager";
import { TranslationKeys, WebsiteIds } from "../../../infrastructure/const";
import IConfigurationContext from "../../../infrastructure/context/configuration/configuration.context.interface";
import ConfigurationContext from "../../../infrastructure/context/configuration/configuration.context";

const LandingPageSimpleWelcomeBanner = (): JSX.Element | null => {
  const context = useContext<ITranslationsContext>(TranslationsContext);
  const configurationContext =
    useContext<IConfigurationContext>(ConfigurationContext);

  const translationManager = new TranslationManager(context);

  const imgClass = useMemo(() => {
    switch (configurationContext.id) {
      case WebsiteIds.ForbrugsshopFree:
        return "forbrugsshop-free";
      case WebsiteIds.ForbrugsshopBattery:
        return "forbrugsshop-battery";
      default:
        return "default-img";
    }
  }, [configurationContext]);

  return (
    <div className="welcome-banner">
      <div className={`welcome-banner__img ${imgClass}`}></div>

      <div className="welcome-banner__wrapper">
        <h1 className="welcome-banner__heading">
          {translationManager.getTranslation(
            TranslationKeys.LANDINGPAGE_WELCOMEMESSAGE
          )}
        </h1>
      </div>
    </div>
  );
};

export default LandingPageSimpleWelcomeBanner;
